import { FETCH_CAPACITY, FETCH_LIVE_CAPACITY, FETCH_CAPACITY_FAIL,  FETCH_LIVE_CAPACITY_FAIL, SAVE_CAPACITY, FETCH_SEQUENCE_CAPACITY, FETCH_SEQUENCE_CAPACITY_FAIL, FETCH_SEQUENCE_CAPACITY_LOADING,
FETCH_EDIT_CAPACITY, FETCH_EDIT_CAPACITY_FAIL, FETCH_EDIT_CAPACITY_LOADING } from './types';
import { SLACK_WEBHOOKS, CYOA_NETWORK_IDS } from '../config';
import axios from 'axios';
import { SlackWebhook } from './utils';
import { history } from '../components/app';

/**
 * Fetch sequence capacity via Busabout API
 *
 * @param {String} sequenceID - MD5 hash
 * @param {number} style - travel style (1,2,3).
 * @param {number} optionals - optionals node (0,1,2).
 * @param {string} city - start city.
 * @param {number} currency - currency (GBP, AUD, USD, CAD).
 * @param {number} stops - number of stops.
 * @param {number} days - number of days.
 * @param {String} tourID - The ID of the tour (europe / USA)
 */
export function FetchSequenceCapacity(sequenceID, style, optionals, city, currency, stops, days, departure = null, bundle=null, custom=null, tourID = CYOA_NETWORK_IDS["europe"].id){

  const HAS_STYLE = (style !== null && style !== undefined) ? `&style=${style}` : "";
  const HAS_OPTIONALS = (optionals !== null && optionals !== undefined) ? `&optionals=${optionals}` : "";
  const HAS_CITY = (city !== null && city !== undefined) ? `&city=${city}` : "";
  const HAS_STOPS = (stops !== null && stops !== undefined) ? `&stops=${stops}` : "";
  const HAS_DAYS = (days !== null && days !== undefined) ? `&days=${days}` : "";
  const HAS_DEPARTURE = (departure !== null && departure !== undefined) ? `&departure=${departure}` : "";
  const HAS_BUNDLE = (bundle !== null) ? `&bundle=${bundle}` : "";
  const HAS_CUSTOM = (custom !== null) ? `&custom=${custom}` : "";
  const SEQUENCE_URL = `${process.env.REACT_APP_NETWORK_API}${tourID}/sequences/${sequenceID}/capacity?api_token=${process.env.REACT_APP_API_TOKEN}&currency=${currency}${HAS_DEPARTURE}${HAS_STOPS}${HAS_DAYS}${HAS_STYLE}${HAS_OPTIONALS}${HAS_CITY}${HAS_BUNDLE}${HAS_CUSTOM}`;


  return async dispatch => {
    dispatch({type:FETCH_SEQUENCE_CAPACITY_LOADING});
    try{
      const data = await axios.get(SEQUENCE_URL);
      dispatch({type:FETCH_SEQUENCE_CAPACITY, payload:data});
    }
    catch(err){
      dispatch({type:FETCH_SEQUENCE_CAPACITY_FAIL});
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! - SEQUENCE API (GET) - '  + SEQUENCE_URL + " " + err}));
      console.error(err);
      history.push('/500');
    }
  }
}

/**
 * Fetch capacity via Busabout API (Capacity fetched from matrix only used for development testing)
 *
 * @param {string} tourID - product tour id.
 * @param {string} currency - currency (GBP, AUD, USD, CAD).
 * @param {string} [cityID] - cityID for hoho trips.
 * @param {object} [saveCapacityPayload] - use for matrix standalone product basket.
 * @param {string} [type] - capacity type for loading different widgets.
 * @param {number} [bookingID] - bookingID for 'Add Destination' and 'Change number days'.
 */
export function FetchCapacity(tourID, currency, cityID, saveCapacityPayload = {}, type = "", bookingID = ""){

  if(Object.keys(saveCapacityPayload).length === 0){

    const hasBookingId = (bookingID !== "") ? `&booking_id=${bookingID}` : "";
    const hasCityID = (cityID !== "") ? `&city_id=${cityID}` : "";
    const capacityURL = `${process.env.REACT_APP_CAPACITY_API}${tourID}?currency=${currency}${hasCityID}&api_token=${process.env.REACT_APP_API_TOKEN}${hasBookingId}`;

    return async dispatch => {

      if(type === "EDIT_DAYS_CAPACITY") dispatch({type:FETCH_EDIT_CAPACITY_LOADING , payload:true});

      try{
        const data = await axios.get(capacityURL, {withCredentials: true});

        if(type === "") dispatch({type:FETCH_CAPACITY, payload:data});
        if(type === "EDIT_DAYS_CAPACITY") dispatch({type:FETCH_EDIT_CAPACITY, payload:data});
        return await Promise.resolve(data.data);
      }
      catch(err){
          dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! CAPACITY API - ' + capacityURL + " " + err}));
          if(type === "") dispatch({type:FETCH_CAPACITY_FAIL});
          if(type === "EDIT_DAYS_CAPACITY") dispatch({type:FETCH_EDIT_CAPACITY_FAIL});
          console.error(err);
          history.push('/500');
      }

    }
  }


  else{

    return dispatch => dispatch({type:SAVE_CAPACITY, payload:saveCapacityPayload})
  }
}

/**
 * Fetch live capacity via Busabout API
 *
 * @param {string} tourID - product tour id.
 * @param {string} currency - iso currency (GBP, AUD, USD, CAD).
 * @param {string} [cityID] - cityID for hoho trips.
 * @param {number} [year] - tour year.
 * @param {number} [month] -tour month.
 * @param {number} [day] - tour day.
 */
export function FetchLiveCapacity(tourID, currency, cityID, year, month, day){

  const hasYear = (year !== "") ? `/${year}/${month}/${day}` : "";
  const hasCityID = (cityID !== "") ? `&city_id=${cityID}` : "";
  const capacityURL =  `${process.env.REACT_APP_CAPACITY_API}${tourID}${hasYear}/live?currency=${currency}${hasCityID}&api_token=${process.env.REACT_APP_API_TOKEN}`;

  return async dispatch => {
    try{
      const data = await axios.get(capacityURL, {withCredentials: true});
      dispatch({type:FETCH_LIVE_CAPACITY, payload:data});
    }
    catch(err){
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! LIVE CAPACITY API - ' + capacityURL + " " + err}));
      dispatch({type:FETCH_LIVE_CAPACITY_FAIL})
      console.error(err);
      history.push('/500');
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/capacity.js